import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { apiRequest } from "../../apiServices/allApi";

export default function Running() {
  const id = localStorage.getItem("id");
  const [challenge, setchallenge] = useState([]);
  const [selectedType, setSelectedType] = useState("");
  const tableRef = useRef();

  const fetchData = async () => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(
        `admin/challange/running`,
        "GET",
        null,
        headers,
      );
      setchallenge(res?.data || []);
    } catch (error) {
      console.error("Error fetching running challenges:", error);
    }
  };

  const dateFormat = (e) => {
    const date = new Date(e);
    return date.toLocaleString("default", {
      month: "short",
      day: "numeric",
      hour: "numeric",
      hour12: true,
      minute: "numeric",
    });
  };

  useEffect(() => {
    fetchData();
  }, [selectedType]);

  return (
    <div className="row mt-4">
      <div className="col-12 grid-margin">
        <div className="card">
          <div className="card-body p-2">
            <div className="d-flex flex-wrap justify-content-between align-items-center mb-3">
              <h4 className="dashboard_heading m-0 text-primary">
                <i className="mdi mdi-run text-primary mr-2"></i> Running
                Challenges
              </h4>
            
            </div>

            <div className="table-responsive">
              <table className="table table-hover" ref={tableRef}>
                <thead>
                  <tr>
                    <th>#</th>
                    {id === "67f8f9731bb8e80965dd62b8" && <th>ID</th>}
                    <th>Creator</th>
                    <th>Accepter</th>
                    <th>Amount</th>
                    <th>Status</th>
                    <th>Game Type</th>
                    <th>Date</th>
                    <th className="text-right pr-4">Action</th>
                  </tr>
                </thead>

                <tbody>
                  {challenge && challenge.length > 0 ? (
                    challenge.map((game, key) => (
                      <tr key={game._id || key}>
                        <td>{key + 1}</td>
                        {id === "67f8f9731bb8e80965dd62b8" && (
                          <td>
                            <code>{game._id?.substring(0, 8)}...</code>
                          </td>
                        )}
                        <td>
                          <strong>{game.Created_by?.Name || "N/A"}</strong>
                        </td>
                        <td>
                          <strong>{game.Accepetd_By?.Name || "N/A"}</strong>
                        </td>
                        <td>
                          <span className="text-success font-weight-bold">
                            ₹{game.Game_Ammount}
                          </span>
                        </td>
                        <td>
                          <span className="badge badge-info">Running</span>
                        </td>
                        <td>
                          <span className="badge">
                            {game.Game_type}
                          </span>
                        </td>
                        <td className="text-muted small">
                          {dateFormat(game.createdAt)}
                        </td>
                        <td className="text-right pr-4">
                          <Link
                            className="btn btn-sm btn-outline-primary"
                            to={`/view/${game._id}`}
                          >
                            <i className="mdi mdi-eye mr-1"></i> View
                          </Link>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="9" className="text-center py-4 text-muted">
                        No running challenges found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
